class SaleCountdown extends HTMLElement {
  connectedCallback() {
    const match = (this.getAttribute('end') || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);

    if (!match) {
      return;
    }

    // The theme setting is entered in IST, so pin the offset instead of trusting the visitor's timezone
    this.endTime = Date.parse(`${match[1]}-${match[2]}-${match[3]}T${match[4]}:${match[5]}:00+05:30`);
    this.timeElement = this.querySelector('.sale-countdown__time');

    if (this.tick()) {
      this.hidden = false;
      this.interval = setInterval(() => this.tick(), 1000);
    }
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = Math.floor((this.endTime - Date.now()) / 1000);

    if (Number.isNaN(remaining) || remaining <= 0) {
      clearInterval(this.interval);
      this.hidden = true;
      return false;
    }

    const days = Math.floor(remaining / 86400);
    const pad = (value) => String(value).padStart(2, '0');
    const clock = `${pad(Math.floor((remaining % 86400) / 3600))}:${pad(Math.floor((remaining % 3600) / 60))}:${pad(remaining % 60)}`;

    this.timeElement.textContent = days > 0 ? `${days}d ${clock}` : clock;
    return true;
  }
}

if (!customElements.get('sale-countdown')) {
  customElements.define('sale-countdown', SaleCountdown);
}
